import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-02/lesson-30/task-01";

const task: Slide = {
  titleHtml:
    "A talker is located around 10 m in front of you. How much earlier do you see his/her<br>lip movement before the sound arrives at your ears ?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
